import { render } from "./coursewareLookVideo.vue?vue&type=template&id=797efa6e&scoped=true"
import script from "./coursewareLookVideo.vue?vue&type=script&lang=js"
export * from "./coursewareLookVideo.vue?vue&type=script&lang=js"

import "./coursewareLookVideo.vue?vue&type=style&index=0&id=797efa6e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797efa6e"]])

export default __exports__